module.exports = __webpack_public_path__ + "img/needle-right1.3a75b598.png";